import { array, object, string } from "yup";

/**
 *
 * @param {Object} otherDetailsParty
 *
 * @param {*} otherDetailsParty.driverIsOwner
 * @param {*} otherDetailsParty.driverAtFault
 * @param {*} otherDetailsParty.hasInfo
 * @param {Object} otherDetailsParty.vehicle
 * @param {*} otherDetailsParty.vehicle.regNo
 * @param {*} otherDetailsParty.vehicle.insuranceCo
 * @param {*} otherDetailsParty.vehicle.policyNo
 * @param {*} otherDetailsParty.vehicle.insuranceCompany
 *  @param {*} otherDetailsParty.vehicle.vehicleMake
 * @param {*} otherDetailsParty.vehicle.vehicleYear
 * @param {*} otherDetailsParty.vehicle.vehicleModel
 * @param {Object} otherDetailsParty.owner
 * @param {*} otherDetailsParty.owner.ownerFname
 * @param {*} otherDetailsParty.owner.ownerLname
 * @param {*} otherDetailsParty.owner.ownerTrn
 * @param {*} otherDetailsParty.owner.ownerPhoneNumber
 * @param {*} otherDetailsParty.owner.ownerEmail
 * @param {*} otherDetailsParty.owner.ownerInjury
 * @param {*} otherDetailsParty.owner.ownerInjuryDetails
 * @param {*} otherDetailsParty.owner.ownerWasDriver
 * @param {*} otherDetailsParty.propertyOwnername
 * @param {*} otherDetailsParty.propertyOwnerPhoneNumber
 * @param {Object} otherDetailsParty.driver
 * @param {*} otherDetailsParty.driver.driverFname
 * @param {*} otherDetailsParty.driver.driverLname
 * @param {*} otherDetailsParty.driver.driverTrn
 * @param {*} otherDetailsParty.driver.driverPhoneNumber
 * @param {*} otherDetailsParty.driver.driverEmail
 * @param {*} otherDetailsParty.driver.driverInjury
 * @param {*} otherDetailsParty.driver.driverInjuryDetails
 * @param {[]} otherDetailsParty.passengers
 * @param {*} otherDetailsParty.panelDetails
 *
 * @returns {Object}
 */
export const defaultFormValues = otherDetailsParty => ({
	driverIsOwner: otherDetailsParty?.driverIsOwner || "",
	driverAtFault: otherDetailsParty?.driverAtFault || "",
	hasInfo: otherDetailsParty?.hasInfo || "",
	regNo: otherDetailsParty?.vehicle?.regNo || "",
	insuranceCo: otherDetailsParty?.vehicle?.insuranceCompany || "",
	policyNo: otherDetailsParty?.vehicle?.policyNo || "",
	vehicleMake: otherDetailsParty?.vehicle?.vehicleMake || "",
	vehicleModel: otherDetailsParty?.vehicle?.vehicleModel || "",
	vehicleYear: otherDetailsParty?.vehicle?.vehicleYear || "",
	ownerFname: otherDetailsParty?.owner?.ownerFname || "",
	ownerLname: otherDetailsParty?.owner?.ownerLname || "",
	ownerTrn: otherDetailsParty?.owner?.ownerTrn || "",
	ownerPhoneNumber: otherDetailsParty?.owner?.ownerPhoneNumber || "",
	ownerEmail: "",
	ownerInjury: "",
	ownerInjuryDetails: "",
	ownerWasDriver: "",
	propertyOwnername: "",
	propertyOwnerPhoneNumber: "",
	driverFname: otherDetailsParty?.driver?.driverFname || "",
	driverLname: otherDetailsParty?.driver?.driverLname || "",
	driverTrn: otherDetailsParty?.driver?.driverTrn || "",
	driverPhoneNumber: otherDetailsParty?.driver?.driverPhoneNumber || "",
	driverEmail: otherDetailsParty?.driver?.driverEmail || "",
	driverInjury: otherDetailsParty?.driver?.driverInjury || "",
	driverInjuryDetails: otherDetailsParty?.driver?.driverInjuryDetails || "",
	passengers: otherDetailsParty?.passengers || [],
	panelDetails: otherDetailsParty?.panelDetails || [],
	companyName:  otherDetailsParty?.company?.companyName || "",
	companyPhoneNumber:  otherDetailsParty?.company?.companyPhoneNumber || "",
	companyEmail:  otherDetailsParty?.company?.companyEmail || "",
	IsCompanyOwned:  otherDetailsParty?.IsCompanyOwned || ""
});
export const TRNMask = [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];
export const phoneNo = [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];

export const schema = object().shape({
	driverIsOwner: string(),
	regNo: string(),
	insuranceCo: string(),
	vehicleMake: string(),
	vehicleModel: string(),
	vehicleYear: string(),
	driverAtFault: string().required("An answer to this question is required."),
	policyNo: string(),
	ownerFname: string().test(
			"First name is required",
			(value, context) => { 
				const { driverIsOwner, IsCompanyOwned } = context.parent;

				if (driverIsOwner === "Yes" || IsCompanyOwned === "Yes") {
				return true;
				}

				if (value === "n/a" && driverIsOwner === "No") {
				return true;
				}

				if (value === undefined || value?.trim() === "") {
				return context.createError({
					message: "First name is required",
				});
				}

				return /^[A-Za-z0-9 ]+$/.test(value.trim());
			}
		),
	ownerLname: string().test(
		"last-name-validation",
		(value, context) => {
			const { driverIsOwner, IsCompanyOwned } = context.parent;

			if (driverIsOwner === "Yes" || IsCompanyOwned === "Yes") {
			return true;
			}

			if (value?.toLowerCase() === "n/a" && driverIsOwner === "No") {
			return true;
			}

			if (!value?.trim()) {
			return context.createError({
				message: "Last name is required.",
			});
			}

			return /^[A-Za-z0-9 ]+$/.test(value.trim());
		}
		),
	ownerTrn: string().matches(/^[\d]{3}-[\d]{3}-[\d]{3}$/, "Please enter a valid TRN"),
	ownerPhoneNumber: string().matches(/^[\d]{3}-[\d]{3}-[\d]{4}$/, "Enter a valid Phone Number"),
	ownerEmail: string()
		.trim("")
		.matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email address"),
	ownerInjury: string(),
	ownerInjuryDetails: string(),
	driverFname: string().required("First name is required."),
	driverLname: string().required("Last name is required."),
	driverTrn: string()
		.matches(/^[\d]{3}-[\d]{3}-[\d]{3}$/, "Please enter a valid TRN"),
	driverPhoneNumber: string().matches(/^[\d]{3}-[\d]{3}-[\d]{4}$/, "Enter a valid Phone Number"),
	driverEmail: string()
		.trim("")
		.matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Please enter a valid Email Address"),
	driverInjury: string().required("Select if the Drive is Injured"),
	driverInjuryDetails: string(), 
	panelDetails: array(),
	companyName: string().test(
		"company-name-validation",
		function (value, context) {
			const { IsCompanyOwned } = context.parent;

			if (value === "n/a" && IsCompanyOwned === "No") {
			return true;
			}

			if (!value?.trim()) {
			return context.createError({
				message: "Enter a Company Name",
			});
			}

			if (!/^[A-Za-z0-9 ]+$/.test(value.trim())) {
			return context.createError({
				message: "Enter a Company Name",
			});
			}

			return true;
		}
		),
	companyPhoneNumber: string().trim("").matches(/^[\d]{3}-[\d]{3}-[\d]{4}$/, "Enter a valid Phone Number"),
	companyEmail: string().trim("").matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Enter a valid email"),
	IsCompanyOwned: string().required("An answer to this question is required."),
});
